module.exports = __webpack_public_path__ + "static/media/salad3.175c1ad7.png";